import * as tslib_1 from "tslib";
/*
 * @Descripttion:
 * @version: v1.0
 * @Author: baidongsheng
 * @Date: 2021-11-12 11:53:15
 * @LastEditors: ymuser yemeng@authine.com
 * @LastEditTime: 2023-05-23 09:36:47
 */
import "babel-polyfill";
import "./config/axios";
import env from "@/config/env";
import * as platform from "@cloudpivot/platform";
import { formApi } from "@cloudpivot/api";
import { startup } from "./startup";
import initFormComponent from "@cloudpivot/form/registerComponent";
import common from "@cloudpivot/common/mobile";
import Vues from "vue";
import infiniteScroll from "vue-infinite-scroll";
//引入svg
import './assets/icons/iconfont.js';
// 二开 引入字体包
import "../extends/assets/Font/font.css";
//   重写window.open接口为/aliyun/download 接口做加密处理
// (window as any).newopen = (window as any).open;
// (window as any).open = function(url,a,b){
//     if(url.indexOf("/api/aliyun/download")>-1){
//         const KEY = env.encrypt_totalRewards.KEY;
//         const IV = env.encrypt_totalRewards.IV;
//         const search = url.split("?")[1];
//         const searchUrl = "?"+search;
//         const redId = (window as any).getQueryString(searchUrl,"refId");
//         const T = (window as any).getQueryString(searchUrl,"T");
//         const refIdEncrypt = encryptApi.encrypt_iv(redId,KEY,IV);
//         const TEncrypt = encryptApi.encrypt_iv(T,KEY,IV);
//         const newurl = url.split("?")[0] + "?refId=" + encodeURIComponent(refIdEncrypt) +"&T=" + TEncrypt ;
//         (window as any).newopen(newurl,a,b);
//     }else{
//         (window as any).newopen(url,a,b)
//     }
// }
window.config.newHireLogin = {
    KEY: "E2842C540F0810C3F11F42427F48A3DE",
    IV: "0123456789ABCDEF"
},
    window.config.encrypt_totalRewards = {
        KEY: "E2842C540F0810C3F11F42427F48A3DE",
        IV: "0123456789ABCDEF"
    },
    window.config.encrypt_onboarding = {
        KEY: "Onboarding_SecretKey_2018",
        IV: "Onboarding_IV_2018"
    };
var host = window.location.protocol + '//' + window.location.host;
if (host.indexOf("bpa-dev.azurechina.cloud") > -1 || host.indexOf("bpm-dev.azure.bmwchina") > -1) { //DEV环境 = 88环境
    window.config.hasSSO = false;
}
else if (host.indexOf("bpa-uat.azurechina.cloud") > -1 || host.indexOf("bpm-uat.azure.bmwchina.cloud") > -1) { //UAT 环境
    window.config.hasSSO = true;
}
else if (host.indexOf("bpa.azurechina.cloud.bmw") > -1 || host.indexOf("bpm.azure.bmwchina.cloud") > -1) { //  prod 环境
    window.config.hasSSO = false;
}
else {
    window.config.hasSSO = true;
}
Vues.use(infiniteScroll);
initFormComponent();
platform.start(env.client_id, env.scope).then((result) => {
    if (!result)
        return;
    const { query } = result;
    if (query.messageId && common.utils.Common.isPC) {
        openMessage(query.messageId);
    }
    else if (query.messageId && !common.utils.Common.isPC) {
        window.location.href = `${env.portalHost}/mobile/?messageId=${query.messageId}`;
    }
    else {
        startup(query);
        // import(/* webpackChunkName: "startup" */'./startup').then( obj => {
        //   obj.startup(query);
        // });
    }
});
Vues.prototype.getPopupContainer = (triggerNode) => {
    // console.log(triggerNode,'triggerNodetriggerNode',triggerNode.parentNode)
    return triggerNode.parentNode.parentNode;
};
/**
 * 根据消息打开页面
 * @param messageId
 */
function openMessage(messageId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const $app = document.getElementById("app");
        if (!$app) {
            throw new Error(`can't find #app`);
        }
        const params = {
            messageId
        };
        const token = localStorage.getItem("token");
        if (token) {
            const res = yield formApi.getMessageFormUrl(params);
            if (res.errcode === 0 && res.data) {
                // 跳转到消息地址或者第三方浏览器直接打开地址
                const { bizObjectId, workItemId, workflowInstanceId, schemaCode, sheetCode, url } = res.data;
                // alert(`结果详情：bizobjectid:${bizObjectId},workitemid:${workItemId},workflowinstanceid:${workflowInstanceId}`);
                let theUrl = "";
                if (url) {
                    if (url.indexOf("?") > -1) {
                        theUrl = `${url}&T=${token}`;
                    }
                    else {
                        theUrl = `${url}?T=${token}`;
                    }
                }
                else {
                    theUrl = `${env.portalHost}/form/detail?`;
                    if (workflowInstanceId) {
                        theUrl += `workflowInstanceId=${workflowInstanceId}&workitemId=${workItemId ||
                            ""}&T=${token}`;
                    }
                    else {
                        theUrl += `objectId=${bizObjectId}&schemaCode=${schemaCode}&sheetCode=${sheetCode}&T=${token}`;
                    }
                }
                $app.innerText = "";
                $app.style.textAlign = "center";
                $app.style.paddingTop = "20px";
                $app.style.color = "#666";
                $app.style.fontSize = "18px";
                const $a = document.createElement("a");
                $a.style.textDecoration = "underline";
                $a.href = theUrl;
                $a.target = "_blank";
                $a.innerText = "浏览器打开应用";
                $app.appendChild($a);
                // window.location.href = theUrl;
                platform.service.openLink(theUrl);
            }
        }
        else {
            localStorage.setItem("isShowEmailResquest", `${env.portalHost}?messageId=${messageId}`);
            const theUrl = `${env.portalHost}/login`;
            window.location.href = theUrl;
        }
    });
}
